import types from './actionTypes'

export const selectPrinter = name => ({
  type: types.UPDATE_SELECT_PRINTER,
  data: name
})

export default {
  selectPrinter
}


// WEBPACK FOOTER //
// ./src/containers/PrinterSetup/store/actions.js